import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import AwardBadge from "@/components/AwardBadge";
import { CVC_LOGO } from "./constants";

export default function Navigation({ onSignup, onNextMove, navBadgeVisible }) {
  return (
    <nav data-testid="main-nav" className="sticky top-0 z-30 bg-cvc-cream/85 backdrop-blur-md border-b border-cvc-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-4 flex items-center justify-between gap-3">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 shrink-0">
          <img src={CVC_LOGO} alt="Cache Valley Consulting" className="h-7 sm:h-10 w-auto shrink-0" />
          <div className="hidden sm:block leading-tight">
            <div className="font-body text-[10px] tracking-[0.25em] uppercase text-cvc-red">Serving Logan since 2018</div>
          </div>
        </a>
        <div className="flex items-start gap-3 sm:gap-6">
          <button
            type="button"
            onClick={onNextMove}
            data-testid="nav-free-diag"
            className="font-body text-sm text-cvc-ink-soft hover:text-cvc-navy transition-colors pt-3 whitespace-nowrap"
          >
            <span className="text-cvc-red font-semibold text-[11px] tracking-[0.15em] mr-1">FREE</span>
            <span className="hidden md:inline">Business </span>Diag
          </button>
          <a href="/#approach" className="hidden md:inline font-body text-sm text-cvc-ink-soft hover:text-cvc-navy transition-colors pt-3" data-testid="nav-approach">Our Approach</a>
          <a href="#jonathan" className="hidden md:inline font-body text-sm text-cvc-ink-soft hover:text-cvc-navy transition-colors pt-3" data-testid="nav-jonathan">Meet Jonathan</a>
          <a href="#qualify" className="hidden md:inline font-body text-sm text-cvc-ink-soft hover:text-cvc-navy transition-colors pt-3" data-testid="nav-qualify">Who fits</a>
          <div className="flex flex-col items-center gap-2 relative">
            <Button
              data-testid="nav-pricing-button"
              onClick={onSignup}
              className="bg-cvc-red hover:bg-cvc-red-deep text-white rounded-full px-4 sm:px-7 py-2.5 h-auto font-body"
            >
              Pricing &amp; Sign Up
            </Button>
            <div
              className={`hidden md:flex absolute top-full mt-1 right-0 z-40 pointer-events-none transition-opacity duration-500 items-center gap-4 ${navBadgeVisible ? "opacity-100" : "opacity-0"}`}
              aria-hidden={!navBadgeVisible}
            >
              <a
                href="https://trustedbusinessawards.com/verify?url=utahbusinessconsultant.com"
                target="_blank"
                rel="noopener noreferrer"
                className="pointer-events-auto"
                data-testid="nav-trusted-business-award"
                aria-label="Trusted Business Awards — Verified"
              >
                <img
                  src="https://trustedbusinessawards.com/public/Awards_Logos/Award_Normal_Gold.png"
                  alt="Trusted Business Awards — Verified"
                  className="drop-shadow-md max-w-none block"
                  style={{ width: 440, height: "auto" }}
                />
              </a>
              <AwardBadge size="xl" align="center" tone="cream" />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
